import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// redux
import { postSupportRequestForm, postSupportRequestFormSuccess, postSupportRequestFormFailure } from '../../redux/SupportRequestFormSlice';

// services
import { postSupportRequestFormApi } from '../../services/SupportRequestFormApi';

// Shared
import { successResponse } from '../../../../shared/types';
import { getErrorMessage } from '../../../../shared/utils/apiRequest';

function* postSupportRequestFormSaga(action: ReturnType<typeof postSupportRequestForm>) {
    try {
        const response: successResponse = yield call(postSupportRequestFormApi.postSupportRequestForm, action.payload);
        const successMessage = response.data.message;
        toast.success(successMessage);
        yield put(postSupportRequestFormSuccess(successMessage));
    } catch (error: any) {
        const message = getErrorMessage(error);
        toast.error(message);
        yield put(postSupportRequestFormFailure(message));
    }
}

export function* supportRequestSaga() {
    yield takeLatest(postSupportRequestForm.type, postSupportRequestFormSaga);
}